import * as React from 'react'

import { Chevron, useToggle } from '@factorialco/deprecated-design-system'
import _ from 'lodash'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import styles from './index.module.scss'

interface Props {
  overflowLimit: number
}

const Popover = (props: React.PropsWithChildren<Props>) => {
  const { overflowLimit, children } = props
  const [isOpen, onClickToggle] = useToggle(false)
  const events = React.Children.toArray(children)
  const isOverflow = events.length > overflowLimit

  const renderCollapse = (numEvents: number) => {
    const count = numEvents - overflowLimit

    return (
      <div tabIndex={0} className={styles.toggle} onClick={onClickToggle(!isOpen)}>
        <span className={styles.text}>
          {isOpen
            ? i18n.t('common.close')
            : i18n.t('dashboard.view_more', {
                count,
              })}
        </span>
        <Chevron direction={isOpen ? 'up' : 'down'} type="terciary" />
      </div>
    )
  }

  if (_.isEmpty(events)) return null

  return (
    <div className={styles.bubble}>
      {events.slice(0, isOpen ? events.length : overflowLimit)}
      {isOverflow && renderCollapse(events.length)}
    </div>
  )
}

export default observer(Popover)
